// extracted by mini-css-extract-plugin
module.exports = {"App":"app_App__3k0rf","AppHeader":"app_AppHeader__CuB20","infoText":"app_infoText__MTY02","boardSection":"app_boardSection__3Vp4M","panelSection":"app_panelSection__24xBm"};